<template>
  <group>
    <cell :title="car.store.name"></cell>
    <cell class="fs26">
      <span slot="icon">联系</span>
      <span slot="after-title">{{contactInfo}}</span>
      <a @click="phoneCall()" slot="value" style="padding:10px 20px;">
        <img src="../../../stylesheets/images/red-phone.png" class="icon-img">
      </a>
    </cell>
    <cell :title="car.store.address" class="fs26">
      <span slot="icon">地址</span>
      <a @click="navigate()" slot="value" style="padding:10px 20px;">
        <img src="../../../stylesheets/images/red-address.png" class="icon-img">
      </a>
    </cell>
    <cell>
      <div slot="after-title">
        <flexbox class="title">
            <flexbox-item>重要信息</flexbox-item>
        </flexbox>
      </div>
    </cell>
    <cell>
      <div slot="after-title">
        <flexbox class="flexbox" v-for="(item, index) in carConfig.importInfo.tit" :key="index">
          <flexbox-item :span="190/690" class="key">{{ item }}</flexbox-item>
          <flexbox-item class="value">{{ importInfo[index] || '--' }}</flexbox-item>
        </flexbox>
        <flexbox class="title">
          <flexbox-item>基本信息</flexbox-item>
        </flexbox>
      </div>
    </cell>
    <cell>
      <div slot="after-title">
        <flexbox class="flexbox" v-for="(item, index) in carConfig.baseInfo.tit" :key="index">
          <flexbox-item :span="190/690" class="key">{{ item }}</flexbox-item>
          <flexbox-item class="value">{{ baseInfo[index] || '--' }}
          </flexbox-item>
        </flexbox>
        <flexbox class="title">
          <flexbox-item>手续信息</flexbox-item>
        </flexbox>
      </div>
    </cell>
    <cell>
      <div slot="after-title">
        <flexbox class="flexbox" v-for="(item, index) in carConfig.formalities.tit" :key="index">
          <flexbox-item :span="190/690" class="key">{{ item }}</flexbox-item>
          <flexbox-item class="value">{{ formalities[index] || '--' }}
          </flexbox-item>
        </flexbox>
      </div>
    </cell>
    <cell is-link title="查看详细配置信息" @click.native="toBasicdetail()"></cell>
    <cell is-link title="查看质检报告" @click.native="toReport()"></cell>
  </group>
</template>
<script>
import {
  Cell,
  Group,
  Flexbox,
  FlexboxItem
} from '@lx-frontend/cvux'

export default {
  components: {
    Cell,
    Group,
    Flexbox,
    FlexboxItem
  },
  props: {
    carInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    car: {
      type: Object,
      default() {
        return {}
      }
    },
    from: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      carConfig: {
        importInfo: {
          tit: ['过户要求', '迁往何处', '买方承担', '卖方承担', '评估简述']
        },
        baseInfo: {
          tit: ['车辆信息', '车辆VIN码', '表显里程', '排量', '排放标准', '出厂日期', '初次上牌', '车辆所在地', '车辆归属地', '车牌', '车辆性质', '使用性质', '驱动形式', '变速形式', '车身颜色', '是否改装']
        },
        formalities: {
          tit: ['购置税', '行驶证', '登记证', '年检到期日', '强险到期日', '商险到期日', '新车发票', '新车质保', '钥匙', '保养手册', '说明书', '未处理违章', '过户次数', '最后过户日期', '过户票', '手续补办费用']
        }
      },
      // 置购税
      purchaseTaxList: [{
        key: '1',
        value: '已征收'
      }, {
        key: '2',
        value: '未征收'
      }, {
        key: '3',
        value: '无'
      }],
      // 补办手续费用
      proceduresSpendList: [{
        key: '1',
        value: '买方承担'
      }, {
        key: '2',
        value: '卖方承担'
      }, {
        key: '3',
        value: '无'
      }],
      // 迁往何处
      newPlaceList: [{
        key: '1',
        value: '本市'
      }, {
        key: '2',
        value: '外迁'
      }, {
        key: '3',
        value: '本市外迁均可'
      }]
    }
  },
  methods: {
    tranListToDict(list) {
      let dict = {}
      list.length > 0 && list.forEach(item => {
        dict[item.key] = item.value
      })
      return dict
    },
    phoneCall() {
      // 联系电话需要区分是车辆。还是撮合的里面的
      window.location.href = 'tel:' + this.contactNumber
    },
    navigate() {
      let address = this.car.store
      if (Object.keys(address).length) {
        this.$wechat.promise.then(wx => {
          wx.openLocationByWx(address.latitude || '', address.longitude || '', address.name || '', address.address || '', address.scale || 12, address.infoUrl || '')
        }, wx => {
          console.log('微信JSSDK校验错误:', wx.res)
        })
      }
    },
    toReport() {
      this.$router.push({
        path: `/check/inspectionsReport/${this.$route.params.id}/${this.from}`
      })
    },
    toBasicdetail() { // 查看详细配置信息
      this.$router.push({
        path: `/check/configReport/${this.$route.params.id}/${this.from}`
      })
    }
  },
  computed: {
    contactName() {
      if (this.car.contact_name) {
        return this.car.contact_name
      } else if (this.car.auction && this.car.auction.contact_name) {
        return this.car.auction.contact_name
      } else if (this.car.auction_match && this.car.auction_match.contact_name) {
        return this.car.auction_match.contact_name
      } else {
        return false
      }
    },
    contactNumber() {
      if (this.car.contact_number) {
        return this.car.contact_number
      } else if (this.car.auction && this.car.auction.contact_number) {
        return this.car.auction.contact_number
      } else if (this.car.auction_match && this.car.auction_match.contact_number) {
        return this.car.auction_match.contact_number
      } else {
        return '--'
      }
    },
    // 联系人
    contactInfo() {
      if (this.contactName) {
        return `${this.contactName}, ${this.contactNumber}`
      } else {
        return '--'
      }
    },
    // 置购税
    purchaseTaxDict() {
      return this.tranListToDict(this.purchaseTaxList)
    },
    // 补办手续费用
    proceduresSpendDict() {
      return this.tranListToDict(this.proceduresSpendList)
    },
    // 迁往何处
    newPlaceDict() {
      return this.tranListToDict(this.newPlaceList)
    },
    buyerPayFor () {
      let rets = []
      const procedure = this.carInfo.info ? this.carInfo.info.procedure || {} : {}
      if (procedure.transferFee !== '1' && procedure.freight !== '1' && procedure.mentionFee !== '1') {
        return '无'
      } else {
        procedure.transferFee === '1' && rets.push('过户费')
        procedure.freight === '1' && rets.push('运费')
        procedure.mentionFee === '1' && rets.push('提档费')
        return rets.join('、')
      }
    },
    sellerPayFor () {
      let rets = []
      const procedure = this.carInfo.info ? this.carInfo.info.procedure || {} : {}
      if (procedure.transferFee !== '2' && procedure.freight !== '2' && procedure.mentionFee !== '2') {
        return '无'
      } else {
        procedure.transferFee === '2' && rets.push('过户费')
        procedure.freight === '2' && rets.push('运费')
        procedure.mentionFee === '2' && rets.push('提档费')
        return rets.join('、')
      }
    },
    // 手续信息
    formalities () {
      const basic = this.carInfo ? this.carInfo : {}
      const procedure = this.carInfo.info ? this.carInfo.info.procedure || {} : {}
      const key = procedure.key ? procedure.key + '把' : ''
      const transferCount = basic.transfer_count ? basic.transfer_count + '次' : '0次'

      const formalities = [this.purchaseTaxDict[procedure.purchaseTax], procedure.drivingLicense, procedure.registration,
        procedure.annualDue, procedure.strongInsurance, procedure.commercialInsurance,
        procedure.carInvoice, procedure.carWarranty, key, procedure.maintenanceManual,
        procedure.instructions, procedure.unHandleIllegal, transferCount, basic.last_transfer_date, procedure.transferTickets, this.proceduresSpendDict[procedure.proceduresSpend]] || []
      return formalities
    },
    // 重要信息
    importInfo () {
      const procedure = this.carInfo.info ? this.carInfo.info.procedure || {} : {}
      const transferRequest = procedure.transferRequest ? procedure.transferRequest + '天内必须完成过户' : ''
      const importInfo = [transferRequest, this.newPlaceDict[procedure.newPlace], this.buyerPayFor, this.sellerPayFor, this.carInfo.note] || []
      return importInfo
    },
    // 基本信息
    baseInfo () {
      const basic = this.carInfo ? this.carInfo : {}
      const info = this.carInfo.info
      const displacement = info ? info.config[0].params[2].value || '' : ''
      const underPanTransmissionType = info ? info.config[0].params[5].value || '' : ''
      const perfDriveType = info ? info.config[0].params[6].value || '' : ''
      const mileage = basic.mileage ? (basic.mileage / 10000).toFixed(2) + '万公里' : ''
      const isRefitted = basic.is_refitted ? '是' : '否'
      const locatedCity = basic.located_city ? basic.located_province + basic.located_city : ''
      const belongedCity = basic.belonged_city ? basic.belonged_province + basic.belonged_city : ''
      const colorName = basic.is_color_changed ? basic.color_name + ',已变更颜色' : basic.color_name

      const baseInfo = [basic.car_model_name, basic.vin, mileage, displacement, basic.emission_standard_name, basic.production_date, basic.license_issued_on, locatedCity, belongedCity, basic.plate_number, basic.car_character_name, basic.usage_character_name, perfDriveType, underPanTransmissionType, colorName, isRefitted]
      return baseInfo
    }
  }
}

</script>
